import { render } from "./ModalWindow.vue?vue&type=template&id=4ed4caa2"
import script from "./ModalWindow.vue?vue&type=script&lang=js"
export * from "./ModalWindow.vue?vue&type=script&lang=js"

import "./ModalWindow.vue?vue&type=style&index=0&id=4ed4caa2&lang=scss"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__